<template>
  <div class="home-ru-box mt-3" :class="{ active: isActive }">
    <div class="head flex-btw">
      <h2>{{ t('recent_chat_list') }}</h2>
      <div class="expand-btn flex-center" @click="toggleBox">
        <IconArrow class="icon" :class="{ rotated: isActive }" />
      </div>
    </div>

    <template v-if="chatList.length > 0">
      <InterpertationUsed :chat-list="chatList" @toggle-favorite="toggleFavorite" @refresh="fetchUserChatList" />

      <div class="view-btn-wrap" v-if="chatList.length > 0">
        <button class="all-view-btn flex-center" @click="goToChatList">
          <span>{{ t('label_view_all') }}</span>
          <IconArrow class="icon" />
        </button>
      </div>
    </template>

    <div class="no-data pd-vertical-7" v-else>
      <div class="icon-area">
        <img :src="'/images/mobile/visual/no-data.svg'" alt="" />
      </div>
      <span>{{ t('no_records') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import InterpertationUsed from '@/components/domains/mobile/InterpertationUsed.vue';
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';
import { useChatList } from '@/composables/domains/mobile/useChatList';
import { CHAT_LIST_SIZE } from '@/utils/constants/mobile';

const router = useRouter();
const { t } = useI18n();

const { chatList, fetchUserChatList, toggleFavorite, setLimit } = useChatList();

const isActive = ref(false);

const toggleBox = () => {
  isActive.value = !isActive.value;
};

const goToChatList = () => {
  router.push({ name: 'app-chat-list', query: { tab: 'all' } });
};

onMounted(async () => {
  setLimit(CHAT_LIST_SIZE);
  await fetchUserChatList();
});
</script>

<style scoped lang="scss">
.home-ru-box {
  &.active {
    max-height: 800px;
    .head {
      padding: 1rem 0 0.5rem;
    }
  }
  background: #fff;
  padding: 0 1.25rem;
  border-radius: $size-m;
  max-height: 56px;
  overflow: hidden;
  transition: all 0.3s ease;
  .head {
    padding: 1rem 0;
    h2 {
      font-size: $font-size-p;
    }
    .expand-btn {
      width: 1.5rem;
      height: 1.5rem;
      border-radius: $size-s;
      svg {
        transition: all 0.3s;
        transform: rotate(180deg);
        &.rotated {
          transform: rotate(0);
        }
      }
      &:hover {
        background: $gray10;
      }
    }
  }
  .view-btn-wrap {
    display: flex;
    justify-content: center;
    padding: 0.5rem 0;
    .all-view-btn {
      padding: 0.75rem 0;
      height: 40px;
      text-decoration: none;
      span {
        font-size: $font-size-psmall;
        color: $color-gray-500;
        font-weight: 500;
      }
      svg {
        transform: rotate(90deg);
      }
    }
  }
}

:deep(.itp-used-area) {
  li {
    border-bottom: 1px solid $color-gray-20;
    &:last-child {
      border-bottom: 0;
    }
  }
}

.itp-used-area {
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    .left-col {
      display: flex;
      align-items: center;
      gap: $size-s;
      .logo-box {
        width: 48px;
        height: 48px;
        border-radius: 1rem;
        border: 1px solid $color-gray-40;
      }
      .room-info {
        .inr {
          display: flex;
          align-items: center;
          gap: $size-s;
          margin-bottom: 2px;
          div {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: $size-xs;
            .personnal {
              color: $color-gray-200;
              font-size: $font-size-xs;
            }
          }
        }
        .tit {
          font-size: $font-size-psmall;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          max-width: 140px;
        }
      }
    }
    .right-col {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .txt-btn {
        font-size: $font-size-psmall;
        padding: 0.5rem 0 0.5rem 0.5rem;
        max-height: 32px;
      }
      .date {
        color: $color-gray-200;
        font-size: $font-size-xs;
        text-align: right;
      }
    }
  }
}
</style>
